module.exports = __webpack_public_path__ + "static/Instagram-8-94197948576608568c581eee6606e3f3.png";